// extracted by css-extract-rspack-plugin
export default {"container":"QuotaBanner-module__container__rfard"};